// Soft UI Dashboard React layouts
import Exchanges from "layouts/Common/Exchanges";

export default function ExchangesTab() {
  return <Exchanges />;
}
